import React from 'react';
import { useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Button } from 'app/src/elements/buttons';
import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import Modal from 'app/src/elements/Modal';

import { CREATE_MAKE } from './queries';

export const FIELDS = {
  code: {
    rules: {
      required: true,
      maxLength: { value: 6, message: 'Maximum length is 6 characters' },
    },
  },
  label: { rules: { required: true, }, },
  notes: { },
  primary: {
    label: 'Primary label for this code?',
    type: 'boolean',
  },
};

const NewMake = ({ setShow, refetch, replace, label }) => {
  const resource =
    replace ? { code: replace.code, primary: replace.primary } : { label };

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: defaultValues({ fields: FIELDS, resource })
  });

  const [createMake] = useMutation(CREATE_MAKE, {
    onCompleted: () => {
      refetch();
      setShow(false);
    }
  });

  const onSubmit = input => {
    createMake({
      variables: {
        ...prepareInput(input, FIELDS),
        replaceId: replace?.id,
      }
    });
  };

  return (
    <Modal title="Create Make" setShow={setShow}>
      <Fields fields={FIELDS} control={control} errors={errors} />

      <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
    </Modal>
  );
};

export default NewMake;
